// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/iconfont.css
// module id = UfKn
// module chunks = 62